import React, { useContext } from 'react';
import { useStoreId } from '@thd-nucleus/experience-context';
import { Col, Row, Carousel } from '@thd-olt-component-react/core-ui';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import { PackagesMiniContext } from '../PackagesMiniContext';

const TransactionalPods = () => {
  const { products } = useContext(PackagesMiniContext);
  const storeId = useStoreId();

  return (
    <Carousel
      breakpoints={{
        sm: { slidesPerGroup: 2, slidesPerView: 2 },
        md: { slidesPerGroup: 2, slidesPerView: 2 },
        lg: { slidesPerGroup: 4, slidesPerView: 4 },
        xl: { slidesPerGroup: 4, slidesPerView: 4 }
      }}
    >
      {products?.map((product, idx) => {
        const { itemId } = product;

        return (
          <Row key={itemId}>
            <Col flatten>
              <ProductPod
                itemId={itemId}
                storeId={storeId}
                key={itemId}
                position={idx}
                hideATC
                hideFavorites
                hideFulfillment
                hideLimitPerOrder
                hidePriceBadge
                hideShippingInfo
                hideShopThisCollection
                hideSavingsText
                showSeeMoreOptions
              />
            </Col>
          </Row>
        );
      }
      )}
    </Carousel>
  );
};

TransactionalPods.displayName = 'TransactionalPods';
TransactionalPods.dataModel = ProductPod.dataModel;

export { TransactionalPods };